/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PinOnIcon = ({ width = 24, height = 24, hidden = false, title = 'Pin On' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m5.646 28 2.379 2.381-3.74 3.669a.5.5 0 0 1-.713-.01l-1.59-1.66a.5.5 0 0 1 .008-.7ZM17.951 32.32h.008L18 26.289 26.293 18l2.27-.023.005-.009a1.446 1.446 0 0 0 1.01-2.47l-4.537-4.538L20.5 6.424a1.446 1.446 0 0 0-2.469 1.011h-.008L18 9.708 9.707 18l-6.025.044v.007a1.429 1.429 0 0 0-1.106.414 1.446 1.446 0 0 0 0 2.047l6.459 6.458 6.457 6.459a1.442 1.442 0 0 0 2.463-1.108Z"
    />
  </svg>`;
};
